<ng-content select="hvac-product-property-list-item-label"></ng-content>
<ng-content select="hvac-product-property-list-item-value"></ng-content>
